<div class="w-full">
    <div class="bg-card p-4 rounded-sm mt-4">
        <table mat-table [dataSource]="plantillas.data" class="w-full table-auto">
            <!-- tipoDocumento Column -->
            <ng-container matColumnDef="tipoDocumento">
                <td mat-cell *matCellDef="let doc" >
                    <div class="flex gap-2 items-center">
                        <div
                            class="flex h-full"
                        >
                            <!-- Icons -->
                            <div class="relative">
                                <mat-icon
                                    class="text-hint opacity-50 icon-size-8"
                                    [svgIcon]="
                                        'heroicons_solid:document'
                                    "
                                ></mat-icon>
                                <div
                                    class="absolute bottom-0 left-0 rounded px-1 text-xs font-semibold leading-5 text-white bg-blue-600"
                                >
                                    DOC
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col">
                            <span class="font-medium leading-5">{{doc.nombreDocumento}}</span>
                            <span  class="text-sm font-normal">
                                Generado {{doc.fechaCreacion | date: 'mediumDate'}} por {{doc.creadoPor.nombreCompleto}}
                            </span>
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- menu Column -->
            <ng-container matColumnDef="menu">
                <td mat-cell *matCellDef="let doc" >
                    <button matButton [matMenuTriggerFor]="menu"> <mat-icon>more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item 
                            *hasPermissions="'renombrar_plantilla'; modulos ['MenuOpcionesPlantilla']"    
                            (click)="actualizarPlantilla(doc)">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:pencil'">
                            </mat-icon>
                            Renombrar Plantilla
                        </button>
                        <button mat-menu-item 
                            (click)="descargar(doc)">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:cloud-arrow-down'">
                            </mat-icon>
                            Descargar
                        </button>
                        <button mat-menu-item 
                            *hasPermissions="'eliminar_plantilla'; modulos ['MenuOpcionesPlantilla']"
                            (click)="borrar(doc)">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:trash'">
                            </mat-icon>
                            Borrar
                        </button>                
                    </mat-menu>
                </td>
            </ng-container>

            
            <tr mat-row *matRowDef="let row; columns: ['tipoDocumento', 'menu']" class="border-b"></tr>
        </table>
        <mat-paginator [length]="plantillas.total" [pageSize]="pageSizes" [hidePageSize]="true"></mat-paginator>
    </div>
    
</div>
